var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.667-7.524h-.934v-3.333a3.85 3.85 0 0 0-1.093-2.694A3.696 3.696 0 0 0 12 7.333c-.99 0-1.94.402-2.64 1.116a3.85 3.85 0 0 0-1.093 2.694v3.333h-.934v.953h9.334v-.953ZM13.4 17.333v-.952h-2.8v.952h2.8Z",
    fill: "#959799"
  })));
};
export default SvgNotification;